/**
 * Action Types Constants
 * https://redux.js.org/basics/actions
 */

const ContentConstants = {
  ADD_PLAYER_TRACK: 'ADD_PLAYER_TRACK',
  GET_CATEGORIES_REQUEST: 'GET_CATEGORIES_REQUEST',
  GET_CATEGORIES_SUCCESS: 'GET_CATEGORIES_SUCCESS',
  GET_CATEGORIES_FAILED: 'GET_CATEGORIES_FAILED',
  GET_CATEGORY_PLAYLIST_REQUEST: 'GET_CATEGORY_PLAYLIST_REQUEST',
  GET_CATEGORY_PLAYLIST_SUCCESS: 'GET_CATEGORY_PLAYLIST_SUCCESS',
  GET_CATEGORY_PLAYLIST_FAILED: 'GET_CATEGORY_PLAYLIST_FAILED',
  GET_PLAYLIST_TRACKS_REQUEST: 'GET_PLAYLIST_TRACKS_REQUEST',
  GET_PLAYLIST_TRACKS_SUCCESS: 'GET_PLAYLIST_TRACKS_SUCCESS',
  GET_PLAYLIST_TRACKS_FAILED: 'GET_CATEGORY_PLAYLIST_FAILED',
  REMOVE_PLAYER_TRACK: 'REMOVE_PLAYER_TRACK',
  SET_PLAYER_HEIGHT: 'SET_PLAYER_HEIGHT',
}

export default ContentConstants;
